import { colors, fontFamily, getCssVariables } from "theme/themeConstants";

const getGlobalStyles = () => ({
  "*, *::before, *::after": {
    boxSizing: "border-box",
  },

  html: {
    height: "100%",
    width: "100%",
  },

  body: {
    fontFamily: fontFamily.primary,
    height: "100%",
    width: "100%",
    margin: "0%",
    backgroundColor: colors.bodyBg,
    overflowX: "hidden",
  },

  "#root": {
    minHeight: "100%",
    width: "100%",
  },

  ":root": getCssVariables(),

  ".appLayout": {
    display: "flex",
    flexDirection: "column",
    minHeight: "100dvh",
    width: "100%",
    overflow: "hidden",
  },

  ".appLayoutContent": {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
  },
});

export default getGlobalStyles;
